import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { message, Popconfirm } from 'antd'
import { UserMeyRealType } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import ProtectedButton from 'component/button/protected-button'
import { FEATURE } from 'constants/feature'
import { UserMeyRealStatusEnum } from 'constants/user-mey-real'

interface ButtonBlockUserProps {
  record: UserMeyRealType
  onSuccess?: () => void
}

const ButtonBlockUser = ({ record, onSuccess }: ButtonBlockUserProps) => {
  const handleBlock = async () => {
    try {
      await AppAdmin.blockUserMeyReal(record._id)
      message.success(`User ${record.email || record.walletAddress} has been blocked`)
      onSuccess?.()
    } catch (error) {
      message.error('Failed to block user')
    }
  }

  const handleUnblock = async () => {
    try {
      await AppAdmin.unblockUserMeyReal(record._id)
      message.success(`User ${record.email || record.walletAddress} has been unblocked`)
      onSuccess?.()
    } catch (error) {
      message.error('Failed to unblock user')
    }
  }

  if (record.status === UserMeyRealStatusEnum.ACTIVE) {
    return (
      <Popconfirm
        title="Block User"
        description="Are you sure you want to block this user?"
        onConfirm={handleBlock}
        okText="Yes"
        cancelText="No"
        okButtonProps={{ danger: true }}
      >
        <ProtectedButton
          type="primary"
          danger
          size="small"
          icon={<LockOutlined />}
          feature={FEATURE.USER_MEY_REAL} requireCRUD
        >
          Block
        </ProtectedButton>
      </Popconfirm>
    )
  }

  return (
    <Popconfirm
      title="Unblock User"
      description="Are you sure you want to unblock this user?"
      onConfirm={handleUnblock}
      okText="Yes"
      cancelText="No"
    >
      <ProtectedButton
        type="primary"
        size="small"
        icon={<UnlockOutlined />}
        feature={FEATURE.USER_MEY_REAL} requireCRUD
      >
        Unblock
      </ProtectedButton>
    </Popconfirm>
  )
}

export default ButtonBlockUser
